import React from 'react';
import {
  List,
  Datagrid,
  Responsive,
  TextInput,
  SimpleList,
  TopToolbar,
  DateField,
  SelectInput,
  ReferenceManyField,
  Pagination
} from 'react-admin';

import Filter from '../../core/components/list/StyledFilter';
import ListTitleBar from '../../core/components/ListTitleBar';
import { makeStyles, Typography } from '@material-ui/core';
import FundTermsIcon from '@material-ui/icons/Work';
import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';
import { fundTermStatus } from './FundTermsLookup';
import StatusSelectField from '../../core/components/StatusSelectField';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';
import PopupField from '../../core/components/grid/PopupField';

const useStyles = makeStyles({
  root: {
    marginRight: 'auto'
  },
  termNameFilterStyle: {
    minWidth: '200px'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();

  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const FundTermsFilter = props => {
  const classes = useStyles();
  return (
    <Filter variant="standard" {...props}>
      <TextInput
        label="Search by Fund Term Name"
        source="name"
        alwaysOn
        options={{ autoComplete: 'off' }}
        parse={predictiveSearchParser}
        format={predictiveSearchFormatter}
        className={classes.termNameFilterStyle}
      />
      <SelectInput
        label="Status"
        source="activeVersion"
        choices={fundTermStatus}
        allowEmpty
      />
    </Filter>
  );
};

const FundTermsName = props => {
  return (
    <ListTitleBar
      type="Fund Terms"
      title="Create New Fund Term"
      createUrl="#/fundterms/create"
      icon={<FundTermsIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

// const FundsColumn = props => {
//   if (size(props.data) > 1) {
//     return <Typography variant="body2">Multiple Funds</Typography>;
//   } else if (props.data && size(props.data) === 1) {
//     let fund = Object.values(props.data)[0];
//     if (fund.fundId === '*') {
//       return <Typography variant="body2">All Funds</Typography>;
//     }
//     return (
//       <ReferenceManyField
//         target="fundId"
//         reference="funds"
//         sortable={false}
//         link={false}
//         {...props}
//       >
//         <FundName fundId={fund.fundId} {...props} />
//       </ReferenceManyField>
//     );
//   }
//   return null;
// };

// const FundName = props => {
//   if (props.fundId && props.data && props.data[props.fundId]) {
//     return (
//       <Typography variant="body2">{props.data[props.fundId].name}</Typography>
//     );
//   }
//   return null;
// };

const FundField = props => {
  const { data } = props;
  const funds = data ? Object.values(data) : [];
  if (funds && funds.length > 1) {
    return (
      <div>
        <PopupField
          data={funds}
          label="Multiple Funds"
          headLabel="Fund Name"
          optionText="fundName"
        />
      </div>
    );
  } else if (funds && funds.length === 1) {
    return <Typography variant="body2">{funds[0].fundName}</Typography>;
  } else return <Typography variant="body2"> </Typography>;
};

const FundTermsList = props => {
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      sort={{ field: 'name', order: 'ASC' }}
      exporter={false}
      title={<FundTermsName hasCreatePermission={hasCreatePermission} />}
      filters={<FundTermsFilter />}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      bulkActionButtons={false}
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.name}
            secondaryText={record => record.activeVersion}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid>
            <LinkField source="name" label="Fund Term Name" />
            <ReferenceManyField
              source="termId"
              target="fundTermId"
              reference="fundtermsrelations"
              link={false}
              label="Fund Name"
              sortable={false}
              sort={{ field: 'fundTermId', order: 'ASC' }}
              {...props}
            >
              <FundField {...props} label="Fund" />
            </ReferenceManyField>
            <DateField source="startDate" label="Start Date" />
            <StatusSelectField
              label="Status"
              source="activeVersion"
              choices={fundTermStatus}
              link={false}
            />
          </Datagrid>
        }
      />
    </List>
  );
};

export default FundTermsList;
